
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","viewBox":"0 0 14 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"9","width":"3","height":"8","rx":".5","fill":"#593289"}}),_c('rect',{attrs:{"x":"5.5","width":"3","height":"17","rx":".5","fill":"#593289"}}),_c('rect',{attrs:{"x":"11","y":"4","width":"3","height":"13","rx":".5","fill":"#593289"}})])
          )
        }
      }
    